import { Navbar, Nav } from 'react-bootstrap'

function Menu() {
  const elements = [
    {
        name: 'INÍCIO',
        path: '/',
        type: 'link'
    },
    {
        name: 'NOTÍCIAS',
        path: '/noticias',
        type: 'link'
    },
    {
        name: 'JORNAL',
        path: '/jornal',
        type: 'link'
    },
    {
        name: 'BENEFÍCIOS',
        path: '/beneficios',
        type: 'link'
    },
    {
        name: 'ASSOCIE-SE',
        path: '/associe-se',
        type: 'link'
    },
    {
        name: 'CONTATO',
        path: '/contato',
        type: 'link'
    }
  ]

  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="menu">
        <Nav className="ms-auto">
          {elements.map((element, index) => {
            return (<Nav.Link key={index} href={element.path} style={{ color: '#FFF' }}>{element.name}</Nav.Link>)
          })}
        </Nav>
      </Navbar.Collapse>
    </>
  );
}

export default Menu;
